export const getQuestions = () => {
    return [
        {
            questionNumber: 1,
            researchQuestion: 'I like to work on cars.',
            category: 'A1'
        },
        {
            questionNumber: 2,
            researchQuestion: 'I like to do puzzles',
            category: 'B2'
        },
        {
            questionNumber: 3,
            researchQuestion: 'I am good at working independently',
            category: 'C1'
        },
        {
            questionNumber: 4,
            researchQuestion: 'I like to work in teams.',
            category: 'D1'
        },
        {
            questionNumber: 5,
            researchQuestion: '.I am an aimbitious person. I set goals for myself',
            category: 'E1'
        },
        {
            questionNumber: 6,
            researchQuestion: 'I like to organize things, ( files, desks, offices)',
            category: 'F1'
        }, {
            questionNumber: 7,
            researchQuestion: 'I like to build things',
            category: 'A2'
        }, {
            questionNumber: 8,
            researchQuestion: 'I like to read about art and music',
            category: 'C2'
        }, {
            questionNumber: 9,
            researchQuestion: 'I like to have clear instructions to follow',
            category: 'F2'
        }, {
            questionNumber: 10,
            researchQuestion: 'I like to try to influence or persuade people',
            category: 'E2'
        }, {
            questionNumber: 11,
            researchQuestion: 'I like to do experiments.',
            category: 'B3'
        }, {
            questionNumber: 12,
            researchQuestion: 'I like to teach or train people',
            category: 'D2'
        }, {
            questionNumber: 13,
            researchQuestion: 'I like trying to help people solve their problems',
            category: 'D3'
        }, {
            questionNumber: 14,
            researchQuestion: 'I like to take care of animals.',
            category: 'A3'
        }, {
            questionNumber: 15,
            researchQuestion: 'I wouldn\'t mind working 8 hours per day in an office',
            category: 'F3'
        }, {
            questionNumber: 16,
            researchQuestion: 'I like selling things.',
            category: 'E3'
        }, {
            questionNumber: 17,
            researchQuestion: 'I enjoy creative writing.',
            category: 'C3'
        }, {
            questionNumber: 18,
            researchQuestion: 'I enjoy science',
            category: 'B4'
        }, {
            questionNumber: 19,
            researchQuestion: 'I am quick to take on new responsibility',
            category: 'E4'
        }, {
            questionNumber: 20,
            researchQuestion: ' I am interested in healing people',
            category: 'D4'
        }, {
            questionNumber: 21,
            researchQuestion: 'I enjoy trying to figure out how things work',
            category: 'B5'
        }, {
            questionNumber: 22,
            researchQuestion: 'I like putting things together or assemblimg things.',
            category: 'A4'
        }, {
            questionNumber: 23,
            researchQuestion: 'I pay attention to details',
            category: 'F4'
        }, {
            questionNumber: 24,
            researchQuestion: 'I am a creative person',
            category: 'C4'
        }, {
            questionNumber: 25,
            researchQuestion: 'I like to do filling or typing',
            category: 'F5'
        }, {
            questionNumber: 26,
            researchQuestion: 'I like to analyse things, (problems/situations ) ',
            category: 'B6'
        }, {
            questionNumber: 27,
            researchQuestion: ' I like to play instruments or sing',
            category: 'C5'
        }, {
            questionNumber: 28,
            researchQuestion: 'I enjoy learning about other cultures. ',
            category: 'D5'
        }, {
            questionNumber: 29,
            researchQuestion: ' I would like to start my own business',
            category: 'E5'
        }, {
            questionNumber: 30,
            researchQuestion: 'I like to cook. ',
            category: 'A5'
        }, {
            questionNumber: 31,
            researchQuestion: 'I like acting in plays. ',
            category: 'C6'
        }, {
            questionNumber: 32,
            researchQuestion: ' I am a practical person',
            category: 'A6'
        }, {
            questionNumber: 33,
            researchQuestion: 'I like working with numbers or charts. ',
            category: 'B7'
        }, {
            questionNumber: 34,
            researchQuestion: 'I like to get into discussion about issues.',
            category: 'D6'
        }, {
            questionNumber: 35,
            researchQuestion: 'I am good at keeping records of my work',
            category: 'F6'
        }, {
            questionNumber: 36,
            researchQuestion: 'I like to lead',
            category: 'E6'
        }, {
            questionNumber: 37,
            researchQuestion: 'I like working outdoors. ',
            category: 'A7'
        }, {
            questionNumber: 38,
            researchQuestion: 'I would like to work in an office',
            category: 'F7'
        }, {
            questionNumber: 39,
            researchQuestion: ' I am good at math.',
            category: 'B1'
        }, {
            questionNumber: 40,
            researchQuestion: '.I like helping people',
            category: 'D7'
        }, {
            questionNumber: 41,
            researchQuestion: 'I like to draw',
            category: 'C7'
        }, {
            questionNumber: 42,
            researchQuestion: 'I like to give speeches',
            category: 'E7'
        }
    ]
};